import React from "react";
import ResultOrShoqa from "./_ResultOrShoqa";
import queryString from "query-string";

const SubjectShoqa = (props) => {
    let {chance = '1'} = queryString.parse(props.location.search);

    const getTitle = () => {
      switch (chance){
          case '2':
              return  "شقه چانس دوم"
          case '3':
              return  "شقه چانس سوم"
          case '1':
          default:
              return  "شقه چانس اول"
      }
    }

    return <ResultOrShoqa {...props} isShoqa={true} chance={chance} title={getTitle()}/>;
};

export default SubjectShoqa;
